module.exports = __webpack_public_path__ + "img/sc-4p-2022.2e99bd7c.jpg";